export default __webpack_public_path__ + "static/media/Logo-Arsenio.11aa7249.png";